import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import HomeIcon from "@mui/icons-material/Home";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PersonIcon from "@mui/icons-material/Person";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {
  Collapse,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Modal,
  Paper,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useAppStore } from "../../appStore";
import { useEffect } from "react";
import axios from "axios";
import { api_url, socket_url, web_url } from "../../apiUtils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WidgetsIcon from "@mui/icons-material/Widgets";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ProfileBadge from "../profile/profileBadge";
import HistoryIcon from "@mui/icons-material/History";
import EventIcon from "@mui/icons-material/Event";
import Notification from "../notification/Notification";
import CasinoIcon from "@mui/icons-material/Casino";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import AddCardIcon from "@mui/icons-material/AddCard";
import PaymentsIcon from "@mui/icons-material/Payments";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import OfflineBoltIcon from "@mui/icons-material/OfflineBolt";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import { toast } from "react-toastify";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RequestDialog from "../../components/Wallet/depositRequest/depositDialog";
import CallIcon from "@mui/icons-material/Call";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import socket from "../../socketClient";

// import ShareAndEarnCard from "./shareAndEarnCard";

const drawerWidth = 260;

const staticMenuItems = [
  {
    text: "Play Game",
    icon: <CasinoIcon />,
    path: "/home/menus",
  },
  {
    text: "Profile",
    icon: <PersonIcon />,
    path: "/profile",
  },
  {
    path: "/settings/select-menus",
    text: "Menus / Games",
    icon: <WidgetsIcon />,
  },
  {
    text: "Wallet [ D-R-P ]",
    icon: <AccountBalanceWalletIcon />,
    path: "/wallet/manage-points",
  },
  {
    path: "/history",
    text: "History",
    icon: <HistoryIcon />,
  },
  {
    text: "Result",
    icon: <EmojiEventsIcon />,
    path: "/result",
  },
  {
    path: "/holiday-list",
    text: "Holiday List",
    icon: <EventIcon />,
  },
  {
    path: "/wallet-statements",
    text: "Wallet Statements",
    icon: <ReceiptLongIcon />,
  },
  // Adding the Call Customer Care item
  // {
  //   text: "Call Customer Care",
  //   icon: <CallIcon />,
  //   path: "tel:+32423432423",
  // },
  {
    text: "Share & Earn",
    icon: <CurrencyRupeeIcon />,
    action: null, // Instead of navigation
  },
];

function Sidebar(props) {
  const { window } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [walletMenuAnchor, setWalletMenuAnchor] = useState(null);
  const {
    profileData,
    walletBalance,
    setWalletBalance,
    setAutoGameBalance,
    setAddPointOpen,
    setWithdrawOpen,
    setCreditLimit,
    addPointOpen,
    walletBalanceUpdated,
    setMessage,
    profileDetails,
  } = useAppStore();
  const [selectedIndex, setSelectedIndex] = React.useState(-1);
  const today = new Date();
  const expiry = new Date(subscriptionDetails?.expiryDate);
  const timeDiff = expiry.getTime() - today.getTime();
  const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));

  // Time left until the end of today (i.e., midnight)
  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);
  const timeLeftToday = endOfToday.getTime() - today.getTime(); // in milliseconds

  const formatTimeLeft = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours} hr : ${String(minutes).padStart(2, "0")} m : ${String(
      seconds,
    ).padStart(2, "0")} s`;
  };

  // const [walletBalance, setWalletBalance] = useState();
  // const toggleSubItems = (index) => {
  //   if (selectedIndex === index) {
  //     setSelectedIndex(-1); // Close sub-items when the same main item is clicked again
  //   } else {
  //     setSelectedIndex(index); // Open sub-items
  //   }
  // };
  let tokenStr = sessionStorage.getItem("accesstoken");

  const getSubscriptionDetails = () => {
    axios
      .get(`${api_url}user/subscription/${profileData?._id}`, {
        headers: {
          accesstoken: tokenStr,
        },
      })
      .then(function (response) {
        if (response.data.status === "success") {
          const data = response.data.subscriptionDetails;
          console.log("res-subscription------------", data);
          // Store full subscription details (so we can show the message)
          setSubscriptionDetails(data);
        }
      })
      .catch(function (error) {
        console.error("Error fetching subscription details:", error);
        setSubscriptionDetails(null); // fallback (no data)
      });
  };
  useEffect(() => {
    getSubscriptionDetails();
    fetchMessages();
  }, [profileData?._id]);

  const getWalletPoints = async () => {
    const response = await axios.get(`${api_url}wallet/balance`, {
      headers: { accesstoken: tokenStr },
    });
    const request = response.data;
    setWalletBalance(request?.walletPoint?.balance);
    setAutoGameBalance(request?.walletPoint?.autoGameBalance || 0);
    setCreditLimit(request?.creditLimit);
    console.log("wallet", walletBalanceUpdated, request);
    return response.data;
  };

  useEffect(() => {
    getWalletPoints();
  }, [walletBalanceUpdated]);

  useEffect(() => {
    const userId = profileData?._id;
    if (!userId) return;

    if (!socket.connected) {
      socket.connect();
    }
    socket.emit("joinRoom", userId);

    const handleWalletBalance = (data) => {
      console.log("Updated wallet balcne:", data);
      const nextBalance = Number(
        data?.balance ?? data?.fullDocument?.balance ?? walletBalance ?? 0,
      );
      setWalletBalance(Number.isFinite(nextBalance) ? nextBalance : 0);
      if (data?.autoGameBalance !== undefined || data?.fullDocument?.autoGameBalance !== undefined) {
        const nextAutoGameBalance = Number(
          data?.autoGameBalance ?? data?.fullDocument?.autoGameBalance ?? 0,
        );
        setAutoGameBalance(
          Number.isFinite(nextAutoGameBalance) ? nextAutoGameBalance : 0,
        );
      }
    };

    const handleForceLogout = () => {
      toast.error("Session ended. Please try again later.");
      sessionStorage.clear();
      navigate("/");
    };

    socket.on("walletBalance", handleWalletBalance);
    socket.on("forceLogout", handleForceLogout);

    return () => {
      socket.off("walletBalance", handleWalletBalance);
      socket.off("forceLogout", handleForceLogout);
    };
  }, [profileData?._id, navigate, setAutoGameBalance, setWalletBalance, walletBalance]);

  const safeWalletBalance = Number.isFinite(Number(walletBalance))
    ? Number(walletBalance).toFixed(2)
    : "0.00";

  const fetchMessages = async () => {
    try {
      const response = await axios.get(`${api_url}user/inbox/message`, {
        headers: { accesstoken: tokenStr },
      });
      const data = response.data;
      setMessage(data);
      console.log(data);
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  // drawer
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleItemClick = (index) => {
    setSelectedItem(index);
  };

  const handleOpenWalletMenu = (event) => {
    setWalletMenuAnchor(event.currentTarget);
  };

  const handleCloseWalletMenu = () => {
    setWalletMenuAnchor(null);
  };
  const handleListItemClick = (index) => {
    if (selectedIndex === index) {
      setSelectedIndex(-1); // Close sub-items when the same sub-item is clicked again
    } else {
      setSelectedIndex(index); // Open sub-items
    }
  };

  useEffect(() => {
    // Find the index that corresponds to the current route
    const index = visibleMenuItems.findIndex(
      (item) =>
        item.path === location.pathname ||
        item.subItems?.some((subItem) => {
          const subPath = subItem.path?.split("?")[0];
          return subPath === location.pathname;
        }),
    );
    setSelectedIndex(index);
  }, [location.pathname, profileData?.userLoginType]);

  const handleManagePointMenu = () => {
    navigate("/wallet/manage-points");
    handleCloseWalletMenu();
  };

  const handleDepositPointMenu = () => {
    navigate("/wallet/deposit-reports");
  };
  const handleWithdrawPointMenu = () => {
    navigate("/wallet/withdraw-reports");
  };

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  // sharing

  function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  const handleShare = async () => {
    const referralId = profileData?.userId || "SO2634"; // fallback
    const shareUrl = `${web_url}/register?ref=${referralId}`;

    // Unicode Safe Star
    const safeStar = "∗"; // U+2217

    const message = `Click the link below to register and start your journey with us. Let’s win together! ✌️
${shareUrl}
    
Reference Phone Number: ${profileDetails?.primaryPhone?.contactValue}
Referred By: ${capitalizeFirstLetter(profileDetails?.name)}
Reference Role: ${capitalizeFirstLetter(profileDetails?.role)}
*Welcome to SM India Family*${safeStar}${safeStar}${safeStar}${safeStar}${safeStar}${safeStar}${safeStar}`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `https://wa.me/?text=${encodedMessage}`;

    console.log(whatsappLink);

    try {
      // Always copy to clipboard first
      await navigator.clipboard.writeText(message);
      toast.success("Invitation copied to clipboard!");

      // Then attempt native share if available
      if (navigator.share) {
        await navigator.share({
          title: "Join & Play",
          text: message,
          // url field intentionally excluded
        });
      }
    } catch (err) {
      console.error("Sharing or copying failed:", err);
      toast.error("Failed to share the invitation.");
    }
  };

  const menuItems = staticMenuItems?.map((item) =>
    item.text === "Share & Earn" ? { ...item, action: handleShare } : item,
  );
  const isHwlUser = profileData?.userLoginType === "HWL";
  const hwlTransferSubItems = [
    {
      text: "ID Transfer",
      icon: <CloudUploadIcon />,
      path: "/transfer/online",
    },
    ...(profileData?.offlineTansferStatus === "active"
      ? [
          {
            text: "Offline Transfer",
            icon: <OfflineBoltIcon />,
            path: "/transfer/offline",
          },
        ]
      : []),
    ...(profileData?.groupTansferStatus === "active"
      ? [
          {
            text: "Group Transfer",
            icon: <Diversity2Icon />,
            path: "/transfer/group",
          },
        ]
      : []),
  ];
  const hwlMenuItems = [
    isMobile
      ? {
          text: "Transfer",
          icon: <ArrowOutwardIcon />,
          path: "/transfer/online",
        }
      : {
          text: "Transfer",
          icon: <ArrowOutwardIcon />,
          subItems: hwlTransferSubItems,
        },
    {
      text: "Wallet",
      icon: <AccountBalanceWalletIcon />,
      subItems: [
        {
          text: "Add / WD",
          icon: <PaymentsIcon />,
          path: "/wallet/manage-points",
        },
        {
          text: "Wallet Statements",
          icon: <ReceiptLongIcon />,
          path: "/wallet-statements",
        },
      ],
    },
    {
      text: "Profile",
      icon: <PersonIcon />,
      path: "/profile",
    },
  ];
  const visibleMenuItems = isHwlUser ? hwlMenuItems : menuItems;
  const currentFullPath = `${location.pathname}${location.search}`;
  const isMenuItemActive = (item, index) =>
    selectedIndex === index ||
    item.path === location.pathname ||
    item.subItems?.some((subItem) => {
      const subPath = subItem.path?.split("?")[0];
      return subItem.path === currentFullPath || subPath === location.pathname;
    });
  const isSubItemActive = (subItem) => {
    const subPath = subItem.path?.split("?")[0];
    return subItem.path === currentFullPath || subPath === location.pathname;
  };
  const handleMenuClick = (item, index) => {
    if (item.action) {
      item.action();
      return;
    }

    if (item.subItems?.length) {
      handleListItemClick(index);
      return;
    }

    if (item.path) {
      navigate(item.path);
      setMobileOpen(false);
    }
  };
  const handleSubMenuClick = (subItem) => {
    navigate(subItem.path);
    setMobileOpen(false);
  };

  const drawer = (
    <div
      style={{
        backgroundColor: "rgba(23 ,27 ,68, 1)", // Semi-transparent background color
        minHeight: "100vh",
        backdropFilter: "blur(10px)", // Add the backdrop-filter for the glass effect
      }}
    >
      <div
        style={{
          background: `url(${process.env.PUBLIC_URL}/images/sidebar-img.png) `, // Set the top 20 pixels background color to red
          height: "64px",
          width: "100%",
          position: "absolute",
          backgroundSize: "cover",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src="/images/sm-logo.png"
          alt="Logo"
          style={{
            height: "80px",
            width: "80px",
            top: "40px",
            position: "relative",
            backgroundColor: "#1b1c1c",
            borderRadius: "50%",
            filter: "contrast(130%)",
            padding: "5px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/home/menus")}
        />
      </div>

      <Toolbar />
      <Typography
        sx={{
          color: "#FFD80A",
          mt: { xs: "55px", md: "50px" },
          textAlign: "center",
          letterSpacing: 1,
          fontSize: "20px",
        }}
      >
        SM-India
      </Typography>
      <Box my={2}>{/* <Divider sx={{ background: "#616161" }} /> */}</Box>
      <Box
        sx={{
          borderRadius: 2,
          backdropFilter: "blur(12px)",
          background:
            "linear-gradient(155deg, rgba(255,255,255,0.12), rgba(255, 255, 255, 0))",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
          mx: 4, // Horizontal margin
          p: 0.5, // Padding
          display: {
            xs: "normal",
            sm: "normal",
            md: "none",
            lg: "none",
            xl: "none",
          },
        }}
      >
        <Box elevation={0} sx={{ backgroundColor: "trans#parent" }}>
          {" "}
          {/* Transparent Paper */}
          <Box mt={0.5} sx={{ display: "flex", alignItems: "center", px: 1 }}>
            <AccountBalanceWalletIcon sx={{ color: "#FFD80A" }} />
            <Box ml={1}>
              {" "}
              <Box sx={{ display: "flex", alignItems: "center", py: 0.5 }}>
                <CurrencyRupeeIcon sx={{ fontSize: "1rem", color: "#fff" }} />
                <Typography
                  sx={{
                    fontSize: "1.2rem",
                    color: "#69f0ae",
                    letterSpacing: 0.5,
                  }}
                >
                  {safeWalletBalance}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        mt={0}
        sx={{
          backgroundColor: "rgba(23 ,27 ,68, 1)", // Semi-transparent background color
        }}
      >
        <List sx={{ mt: 1, mx: { xs: 4, sm: 2 } }}>
          {visibleMenuItems.map((item, index) => {
            const isActive = isMenuItemActive(item, index);

            if (!isHwlUser) {
              return (
                <React.Fragment key={item.text}>
                  <ListItem
                    sx={{
                      display: "block",
                      borderRadius: 3,
                      padding: { xs: 0.5, lg: "normal" },
                      background:
                        selectedIndex === index ? "#FFD80A" : "transparent",
                    }}
                    onClick={item.action || (() => handleListItemClick(index))}
                  >
                    <Link
                      to={item.path}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={toggleExpand}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: !mobileOpen ? 1.5 : 1,
                          ml: { xs: 1, md: 2 },
                          color:
                            selectedIndex === index ? "#000000" : "#FFD80A",
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.text}
                        selected={selectedIndex === index}
                        sx={{
                          color:
                            selectedIndex === index ? "#000000" : "#FFD80A",
                          fontWeight:
                            selectedIndex === index ? "bold" : "normal",
                          mt: 0.8,
                        }}
                      />
                    </Link>
                  </ListItem>
                </React.Fragment>
              );
            }

            return (
              <React.Fragment key={item.text}>
                <ListItem
                  sx={{
                    display: "block",
                    borderRadius: 3,
                    p: 0,
                    mb: 0.75,
                    overflow: "hidden",
                    background: isActive ? "#FFD80A" : "transparent",
                    transition: "background 180ms ease, transform 180ms ease",
                    "&:hover": {
                      background: isActive
                        ? "#FFD80A"
                        : "rgba(255, 216, 10, 0.12)",
                    },
                  }}
                  onClick={() => handleMenuClick(item, index)}
                >
                  <Box
                    sx={{
                      textDecoration: "none",
                      color: "inherit",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      minHeight: 44,
                      px: 2,
                      cursor: "pointer",
                    }}
                  >
                    {/* <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  > */}
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        // width: "20px",

                        mr: !mobileOpen ? 1.5 : 1,
                        ml: 0.5,
                        color: isActive ? "#000000" : "#FFD80A",
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.text}
                      selected={isActive}
                      sx={{
                        color: isActive ? "#000000" : "#FFD80A",
                        fontWeight: isActive ? "bold" : "normal",
                        my: 0,
                      }}
                    />
                    {item.subItems ? (
                      // <ExpandMoreIcon
                      //   sx={{
                      //     color: selectedIndex === index ? "#1E89FF" : "#FFD80A",
                      //     ml: 1,
                      //   }}
                      // />
                      selectedIndex === index ? (
                        <ExpandLessIcon
                          sx={{
                            color: isActive ? "#000000" : "#FFD80A",
                            ml: 1,
                            mt: 0.3,
                          }}
                        />
                      ) : (
                        <ExpandMoreIcon
                          sx={{
                            color: isActive ? "#000000" : "#FFD80A",
                            ml: 1,
                            mt: 0.3,
                          }}
                        />
                      )
                    ) : null}
                    {/* </Box> */}
                  </Box>
                </ListItem>

                {item.subItems && (
                  <Collapse
                    in={selectedIndex === index}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List sx={{ pt: 0.5, pb: 1, ml: 1.5, mb: 0.75 }}>
                      {item.subItems.map((subItem) => {
                        const isSubActive = isSubItemActive(subItem);

                        return (
                          <ListItem
                            key={subItem.text}
                            onClick={() => handleSubMenuClick(subItem)}
                            sx={{
                              p: "2px 0px",
                              pl: 1,
                              minHeight: 34,
                              borderRadius: 2,
                              cursor: "pointer",
                              background: isSubActive
                                ? "rgba(255, 216, 10, 0.22)"
                                : "transparent",
                              "&:hover": {
                                background: "rgba(255, 216, 10, 0.14)",
                              },
                            }}
                          >
                            <Box
                              sx={{
                                textDecoration: "none",
                                color: "inherit",
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: 1.25,
                                  ml: { xs: 1, md: 3.5 },
                                  color: isSubActive ? "#69f0ae" : "#FFD80A",
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 21,
                                  },
                                }}
                              >
                                {subItem.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={subItem.text}
                                selected={isSubActive}
                                sx={{
                                  color: isSubActive ? "#69f0ae" : "#FFD80A",
                                  fontWeight: isSubActive ? "bold" : "normal",
                                }}
                              />
                            </Box>
                          </ListItem>
                        );
                      })}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            );
          })}
        </List>

        {/* Subscription card is temporarily hidden while the new rate slabs
            promotion is displayed. Change false to true to restore it. */}
        {false &&
          !isHwlUser &&
          (profileData?.subscriptionActive === true &&
          subscriptionDetails !== null ? (
            <Box
              sx={{
                px: 1,
                py: { xs: 1, sm: 2.5 },
                m: { xs: 2, sm: 2 },
                borderRadius: 4,
                backdropFilter: "blur(12px)",
                background:
                  "linear-gradient(155deg, rgba(255,255,255,0.12), rgba(255, 255, 255, 0))",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
                color: "white",
                maxWidth: "230px",
                mx: "auto",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  mb: 2,
                  // color: "#ff6d00",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  // fontWeight: "bold",
                  fontSize: 16,
                }}
              >
                <AccessTimeIcon sx={{ fontSize: 18 }} />
                Subscription Details
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  fontSize: "1rem",
                  color: "#FFD80A",
                }}
              >
                Valid Till :{" "}
                {new Date(subscriptionDetails?.expiryDate).toLocaleDateString(
                  "en-GB",
                )}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  fontSize: "0.8rem",
                  color: "#ff",
                }}
              >
                After subscription end you will get Regular Winning Rates.
              </Typography>

              {daysLeft <= 5 && daysLeft >= 0 && (
                <Typography
                  variant="body2"
                  sx={{
                    mt: 3,
                    p: 1.5,
                    borderRadius: "12px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: "#69f0ae",
                    // fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    fontSize: "0.95rem",
                  }}
                >
                  {!profileData?.subscriptionActive ? (
                    <>
                      <WarningAmberRoundedIcon sx={{ fontSize: 20 }} />
                      Your subscription has expired.
                    </>
                  ) : daysLeft < 2 ? (
                    <>
                      <WarningAmberRoundedIcon sx={{ fontSize: 20 }} />
                      Your subscription expiring today.
                    </>
                  ) : (
                    <>
                      <WarningAmberRoundedIcon sx={{ fontSize: 20 }} />
                      Your subscription expires in {daysLeft} day
                      {daysLeft !== 1 ? "s" : ""}!
                    </>
                  )}
                </Typography>
              )}
            </Box>
          ) : (
            <Box
              sx={{
                px: 1,
                py: { xs: 1, sm: 2.5 },
                m: { xs: 2, sm: 2 },
                borderRadius: 4,
                backdropFilter: "blur(12px)",
                background:
                  "linear-gradient(155deg, rgba(255,255,255,0.12), rgba(255, 255, 255, 0))",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
                color: "white",
                maxWidth: "230px",
                mx: "auto",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  mb: 2,
                  // color: "#ff6d00",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  // fontWeight: "bold",
                  fontSize: 16,
                }}
              >
                <AccessTimeIcon sx={{ fontSize: 18 }} />
                Subscription Details
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  fontSize: "1rem",
                  color: "#69f0ae",
                }}
              >
                Renew Your Subscription For Special Winning Rates
              </Typography>
              {/* <Typography
            variant="body1"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              fontSize: "0.8rem",
              color: "#ff",
            }}
          >
            After subscription end you will get Regular Winning Rates.
          </Typography> */}
            </Box>
          ))}

        {!isHwlUser && (
          <Box
            sx={{
              position: "relative",
              overflow: "hidden",
              px: 1.25,
              py: 1.1,
              my: 1,
              borderRadius: 3,
              background:
                "linear-gradient(145deg, rgba(255,216,10,0.18) 0%, rgba(23,27,68,0.98) 48%, rgba(105,240,174,0.14) 100%) padding-box, linear-gradient(90deg, #FFD80A, #69f0ae, #8c9eff, #FFD80A) border-box",
              backgroundSize: "100% 100%, 300% 100%",
              border: "1.5px solid transparent",
              animation: "rateBorderRun 3s linear infinite",
              boxShadow:
                "0 10px 28px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.12)",
              color: "#fff",
              maxWidth: 190,
              mx: "auto",
              textAlign: "center",
              "@keyframes rateBorderRun": {
                "0%": { backgroundPosition: "0 0, 0% 50%" },
                "100%": { backgroundPosition: "0 0, 300% 50%" },
              },
              "&::after": {
                content: '""',
                position: "absolute",
                width: 56,
                height: 56,
                bottom: -34,
                left: -20,
                borderRadius: "50%",
                background: "rgba(105, 240, 174, 0.12)",
              },
            }}
          >
            <Typography
              sx={{
                position: "relative",
                color: "#FFD80A",
                fontSize: "0.57rem",
                fontWeight: 800,
                letterSpacing: 1.25,
                textTransform: "uppercase",
              }}
            >
              New winning rates
            </Typography>

            <Typography
              sx={{
                position: "relative",
                mt: 0.25,
                fontSize: "0.82rem",
                fontWeight: 700,
                lineHeight: 1.3,
                letterSpacing: 0.5,
              }}
            >
              Enjoy the New Rate Slabs
            </Typography>

            <Box
              sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                gap: 0.8,
                my: 0.75,
              }}
            >
              {["R2", "R3"].map((rate) => (
                <Box
                  key={rate}
                  component="button"
                  type="button"
                  onClick={() => navigate(`/profile?tab=4&ratio=${rate}`)}
                  sx={{
                    minWidth: 47,
                    py: 0.45,
                    px: 0.85,
                    borderRadius: 2,
                    color: "#171b44",
                    background:
                      rate === "R2"
                        ? "linear-gradient(135deg, #FFD80A, #ffec70)"
                        : "linear-gradient(135deg, #69f0ae, #b9f6ca)",
                    boxShadow: "0 5px 14px rgba(0,0,0,0.25)",
                    fontSize: "0.9rem",
                    fontWeight: 900,
                    letterSpacing: 1,
                    border: 0,
                    cursor: "pointer",
                    position: "relative",
                    transition:
                      "transform 180ms ease, box-shadow 180ms ease, filter 180ms ease",
                    "&:hover": {
                      transform: "translateY(-2px) scale(1.04)",
                      boxShadow: "0 8px 18px rgba(0,0,0,0.32)",
                      filter: "brightness(1.04)",
                    },
                    "&:active": {
                      transform: "translateY(0) scale(0.98)",
                    },
                    "&:focus-visible": {
                      outline: "2px solid #fff",
                      outlineOffset: 2,
                    },
                  }}
                  aria-label={`Open ${rate} winning rates`}
                >
                  {rate}
                </Box>
              ))}
            </Box>

            <Typography
              sx={{
                position: "relative",
                color: "rgba(255,255,255,0.82)",
                fontSize: "0.61rem",
                lineHeight: 1.35,
              }}
            >
              Better slabs. Better winning rates. More reasons to play!
            </Typography>
          </Box>
        )}

        <Box>
          <Typography
            sx={{
              color: "white",
              textAlign: "center",
              fontSize: "0.7rem",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {isHwlUser ? (
              <span>v_1.0_HWL</span>
            ) : (
              <>
                {/* v_1.0.2 & 21-11-24 */}
                {/* v_1.0.3 & 26-11-24 */}
                v_1.0.7 & 08-08-26
                {/* <span>v_1.0.6 & 30-04-25</span>
                <span>v_1.0.6 & 28-05-25</span> */}
              </>
            )}
          </Typography>
        </Box>
      </Box>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer - 1,
          backgroundColor: {
            xs: "#212762",
            sm: "#212762",
            md: "#212762",
            lg: "#f5f5f5",
          },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { lg: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Grid container>
            <Grid item xs={0} sm={2}></Grid>
            <Grid item xs={12} sm={10}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "space-between", md: "space-around" },

                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    color: {
                      xs: "#ffffff",
                      sm: "#ffffff",
                      md: "#ffffff",
                      lg: "#212762",
                    },
                    fontSize: { xs: "12px", sm: "16px" },
                    display: { xs: "grid", md: "flex" },
                    // ml: { xs: 0, sm: 0, md: 2 },
                    mr: 6,
                    whiteSpace: "nowrap",
                    fontWeight: { xs: "none", lg: "bold" },
                    letterSpacing: 0.5,
                  }}
                  onClick={() => {
                    navigator.clipboard.writeText(profileData?.userId);
                    toast.success("UserId Copied.");
                  }}
                >
                  User Id:{" "}
                  <Typography
                    sx={{
                      color: { xs: "orange", sm: "green", md: "green" },
                      fontWeight: { xs: "none", md: "bold" },
                      fontSize: { xs: "12px", sm: "16px" },
                      ml: { xs: 0, sm: 0, md: 0.5 },
                    }}
                  >
                    {profileData?.userId}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    color: {
                      xs: "#ffffff",
                      sm: "#ffffff",
                      md: "#ffffff",
                      lg: "#212762",
                    },
                    fontSize: { xs: "12px", sm: "16px" },

                    display: { xs: "grid", md: "flex" },
                    alignItems: "center",
                    mr: 2,
                    whiteSpace: "nowrap",
                    fontWeight: { xs: "none", sm: "bold" },
                    letterSpacing: 0.5,
                  }}
                >
                  Available Points:{" "}
                  <Typography
                    sx={{
                      color: { xs: "#76ff03", md: "red" },
                      fontWeight: { xs: "none", md: "bold" },
                      fontSize: { xs: "12px", sm: "18px" },
                      whiteSpace: "nowrap",
                      ml: { xs: 0, sm: 0, md: 0.5 },
                      letterSpacing: 1,
                    }}
                  >
                    {safeWalletBalance}
                  </Typography>
                </Box>

                {/* notification */}
                <Box sx={{ mx: 2 }}>
                  <Notification />
                </Box>

                <Box
                  sx={{
                    "&:hover": {
                      background: { xs: "none", md: "#ffe0b2" },
                      borderRadius: { xs: 0, md: 4 },
                      px: { xs: 0, md: 1 },
                    },
                  }}
                >
                  <ProfileBadge />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { lg: drawerWidth }, flexShrink: { lg: 0 } }}
        aria-label="mailbox folders"
      >
        {/* Temporary Drawer for screens smaller than lg */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "block", md: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              overflowX: "hidden",
              scrollbarWidth: "thin",
              scrollbarColor: "rgba(220,224,232,.52) transparent",
              "&::-webkit-scrollbar": { width: 5 },
              "&::-webkit-scrollbar-track": { background: "transparent" },
              "&::-webkit-scrollbar-thumb": {
                minHeight: 48,
                borderRadius: 999,
                background: "rgba(220,224,232,.48)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(235,238,244,.68)",
              },
              "&::-webkit-scrollbar-button": {
                display: "none",
                width: 0,
                height: 0,
              },
            },
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          {drawer}
        </Drawer>

        {/* Permanent Drawer for lg screens and above */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "none", md: "none", lg: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              overflowX: "hidden",
              scrollbarWidth: "thin",
              scrollbarColor: "rgba(220,224,232,.52) transparent",
              "&::-webkit-scrollbar": { width: 5 },
              "&::-webkit-scrollbar-track": { background: "transparent" },
              "&::-webkit-scrollbar-thumb": {
                minHeight: 48,
                borderRadius: 999,
                background: "rgba(220,224,232,.48)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(235,238,244,.68)",
              },
              "&::-webkit-scrollbar-button": {
                display: "none",
                width: 0,
                height: 0,
              },
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box>
        <Menu
          anchorEl={walletMenuAnchor}
          open={Boolean(walletMenuAnchor)}
          onClose={handleCloseWalletMenu}
          anchorOrigin={{
            vertical: "bottom", // Align the menu to the bottom
            horizontal: "right", // Align the menu to the right
          }}
          transformOrigin={{
            vertical: "top", // Position the menu's top to the bottom of the anchor element
            horizontal: "right", // Align the right edges of the menu and the anchor
          }}
        >
          <MenuItem onClick={handleManagePointMenu}>Manage Points</MenuItem>
          {/* <MenuItem onClick={handleWithdrawPointMenu}>
            Withdraw Reports
          </MenuItem> */}
          {/* <MenuItem onClick={handleDepositPointMenu}>Deposit Reports</MenuItem> */}
        </Menu>

        <Modal
          open={addPointOpen}
          // onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "calc(100% - 24px)", sm: 520 },
              maxWidth: 520,
              boxSizing: "border-box",
              maxHeight: {
                xs: "calc(100dvh - 24px)",
                sm: "calc(100vh - 48px)",
              },
              overflow: "hidden",
              bgcolor: "background.paper",
              boxShadow: "0 24px 70px rgba(10, 16, 45, 0.3)",
              p: { xs: 1, sm: 3 },
              borderRadius: { xs: 2, sm: 4 },
            }}
          >
            <RequestDialog />
          </Box>
        </Modal>
      </Box>
    </Box>
  );
}

export default Sidebar;
